import api from '@/api';

export function listCustomerInspectionReports() {
  return api.get('/dashboard/customer/inspection-reports');
}

export function listAdminInspectionReports() {
  return api.get('/admin/inspection-reports');
}

/**
 * @param {File} file
 * @param {string} customerLookup Company name, contact name, email, or customer id
 * @param {string} [title]
 */
export function uploadAdminInspectionReport(file, customerLookup, title) {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('customer', String(customerLookup).trim());
  if (title != null && String(title).trim() !== '') {
    fd.append('title', String(title).trim());
  }
  return api.post('/admin/inspection-reports', fd, {
    transformRequest: [
      (data, headers) => {
        if (data instanceof FormData) {
          delete headers['Content-Type'];
        }
        return data;
      },
    ],
  });
}

function blobFileNameFromHeaders(headers, fallback) {
  let name = fallback || 'file';
  const cd = headers['content-disposition'];
  if (cd) {
    const m = /filename\*?=(?:UTF-8'')?([^;\n]+)/i.exec(cd);
    if (m) {
      name = decodeURIComponent(m[1].replace(/['"]/g, '').trim());
    }
  }
  return name;
}

export async function downloadCustomerInspectionReportFile(reportId, fallbackFileName) {
  const { data, headers } = await api.get(`/dashboard/customer/inspection-reports/${reportId}/file`, { responseType: 'blob' });
  const name = blobFileNameFromHeaders(headers, fallbackFileName);
  const url = URL.createObjectURL(data);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

/** Open report in a new tab (PDF and images work best). */
export async function viewCustomerInspectionReportInNewTab(reportId) {
  const { data } = await api.get(`/dashboard/customer/inspection-reports/${reportId}/file`, { responseType: 'blob' });
  const url = URL.createObjectURL(data);
  window.open(url, '_blank', 'noopener');
  setTimeout(() => URL.revokeObjectURL(url), 120_000);
}

export async function downloadAdminInspectionReportFile(reportId, fallbackFileName) {
  const { data, headers } = await api.get(`/admin/inspection-reports/${reportId}/file`, { responseType: 'blob' });
  const name = blobFileNameFromHeaders(headers, fallbackFileName);
  const url = URL.createObjectURL(data);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
